import { c as _c } from "react/compiler-runtime";
import { FeatherSend } from '@subframe/core';
import { Paperclip } from 'lucide-react';
import { useEffect, useRef } from 'react';
import type { SimulacaoChatPreviewProps } from '../types';
import { SimulacaoMessageBubble } from './SimulacaoMessageBubble';
export const SimulacaoChatPreview = t0 => {
  const $ = _c(73);
  const {
    agentName,
    started,
    situation,
    messages,
    cleared,
    answeredMessageIds,
    activeInteractionId,
    inputEnabled,
    sending,
    draft,
    draftMaxLength,
    onDraftChange,
    onSend,
    composerStatus,
    onRetry,
    attachEnabled,
    acceptedFileTypes,
    onAttach,
    onReply,
    unavailableFileIds,
    simulacaoId,
    onOpenFile,
    onFileUnavailable,
    typing,
    superficie: t1
  } = t0;
  const superficie = t1 === undefined ? "ESCRITORIO" : t1;
  const messageListRef = useRef(null);
  const fileInputRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const list = messageListRef.current;
      if (list) {
        list.scrollTop = list.scrollHeight;
      }
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== messages.length || $[2] !== typing) {
    t3 = [messages.length, typing];
    $[1] = messages.length;
    $[2] = typing;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex h-6 shrink-0 items-center justify-between bg-neutral-100 px-4 text-[10px] font-semibold text-neutral-700"><span>Simulação</span><span aria-hidden="true">●●● ▰</span></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="bg-brand-100 text-brand-700 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold" aria-hidden="true">L</span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = agentName || "Lexi";
  let t7;
  if ($[6] !== t6) {
    t7 = <strong className="truncate text-sm font-semibold">{t6}</strong>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-xs text-neutral-500">Lexi · agente</span>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7) {
    t9 = <span className="flex min-w-0 flex-1 flex-col">{t7}{t8}</span>;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== situation) {
    t10 = situation && <span className="bg-brand-100 text-brand-700 rounded-md px-1.5 py-1 text-[10px] font-semibold">{situation}</span>;
    $[11] = situation;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <div className="flex h-16 shrink-0 items-center gap-3 border-b border-solid border-neutral-200 bg-neutral-100 px-4 text-neutral-800">{t5}{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== activeInteractionId || $[17] !== answeredMessageIds || $[18] !== cleared || $[19] !== messages || $[20] !== onFileUnavailable || $[21] !== onOpenFile || $[22] !== onReply || $[23] !== simulacaoId || $[24] !== started || $[25] !== superficie || $[26] !== unavailableFileIds) {
    t12 = !started ? <p className="max-w-[250px] self-center rounded-[8px] bg-white px-3 py-2 text-center text-xs leading-relaxed text-neutral-600 shadow-sm">Selecione um agente, preencha os dados necessários e inicie a simulação.</p> : messages.length === 0 && cleared ? <p className="max-w-[250px] self-center rounded-[8px] bg-white px-3 py-2 text-center text-xs leading-relaxed text-neutral-600 shadow-sm">Visualização limpa. O histórico continua disponível em Baixar conversa. Escreva como cliente ou reinicie para voltar ao começo.</p> : messages.length === 0 ? <p className="max-w-[250px] self-center rounded-[8px] bg-white px-3 py-2 text-center text-xs leading-relaxed text-neutral-600 shadow-sm">Nenhuma mensagem ainda. A conversa aparece aqui assim que a Lexi ou você escrever.</p> : messages.map(message => <SimulacaoMessageBubble key={message.id} message={message} answered={message.kind === "interactive" && answeredMessageIds.includes(message.interaction.messageId)} interactionEnabled={message.kind === "interactive" && message.interaction.messageId === activeInteractionId} fileUnavailable={message.kind === "file" && message.file.fileId !== null && unavailableFileIds.includes(message.file.fileId)} onReply={onReply} simulacaoId={simulacaoId} onOpenFile={onOpenFile} onFileUnavailable={onFileUnavailable} superficie={superficie} />);
    $[16] = activeInteractionId;
    $[17] = answeredMessageIds;
    $[18] = cleared;
    $[19] = messages;
    $[20] = onFileUnavailable;
    $[21] = onOpenFile;
    $[22] = onReply;
    $[23] = simulacaoId;
    $[24] = started;
    $[25] = superficie;
    $[26] = unavailableFileIds;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== typing) {
    t13 = typing && <div role="status" aria-label={"Lexi est\xE1 digitando"} className="flex w-fit items-center gap-1 self-start rounded-[8px] rounded-bl-sm bg-white px-3 py-3 shadow-sm"><span className="sr-only">Lexi está digitando</span>{[0, 1, 2].map(_temp)}</div>;
    $[28] = typing;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div ref={messageListRef} data-dd-privacy="mask" className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto px-4 py-5" aria-live="polite">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== onSend) {
    t15 = event => {
      event.preventDefault();
      onSend();
    };
    $[33] = onSend;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== onAttach) {
    t16 = event_0 => {
      const file = event_0.target.files?.[0];
      if (file) {
        onAttach(file);
      }
      event_0.target.value = "";
    };
    $[35] = onAttach;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== acceptedFileTypes || $[38] !== t16) {
    t17 = <input ref={fileInputRef} type="file" tabIndex={-1} aria-hidden="true" accept={acceptedFileTypes} className="hidden" onChange={t16} />;
    $[37] = acceptedFileTypes;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const t18 = !attachEnabled;
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => fileInputRef.current?.click();
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Paperclip className="h-4 w-4" aria-hidden="true" />;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t18) {
    t21 = <button type="button" aria-label="Anexar arquivo como cliente" disabled={t18} onClick={t19} className="flex h-10 w-8 shrink-0 items-center justify-center text-neutral-600 disabled:cursor-not-allowed disabled:opacity-50">{t20}</button>;
    $[42] = t18;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  const t22 = composerStatus ? "simulacao-status-do-envio" : undefined;
  const t23 = !inputEnabled;
  let t24;
  if ($[44] !== onDraftChange) {
    t24 = event_1 => onDraftChange(event_1.target.value);
    $[44] = onDraftChange;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== draft || $[47] !== draftMaxLength || $[48] !== t22 || $[49] !== t23 || $[50] !== t24) {
    t25 = <textarea aria-label="Sua mensagem como cliente" aria-describedby={t22} placeholder="Escreva como cliente..." value={draft} rows={3} maxLength={draftMaxLength} disabled={t23} onChange={t24} className="focus:outline-brand-600 min-h-20 min-w-0 flex-1 resize-none rounded-[8px] border border-solid border-neutral-200 bg-white px-3 py-2 text-sm text-neutral-800 placeholder:text-neutral-400 disabled:cursor-not-allowed" />;
    $[46] = draft;
    $[47] = draftMaxLength;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== draft || $[53] !== inputEnabled || $[54] !== sending) {
    t26 = !inputEnabled || sending || !draft.trim();
    $[52] = draft;
    $[53] = inputEnabled;
    $[54] = sending;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <FeatherSend className="h-4 w-4" />;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t26) {
    t28 = <button type="submit" aria-label="Enviar mensagem como cliente" disabled={t26} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--wa-brand-header)] text-white disabled:cursor-not-allowed disabled:opacity-50">{t27}</button>;
    $[57] = t26;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t15 || $[60] !== t17 || $[61] !== t21 || $[62] !== t25 || $[63] !== t28) {
    t29 = <form data-dd-privacy="mask" className="flex shrink-0 items-end gap-2 border-t border-solid border-neutral-200 bg-neutral-100 p-3" onSubmit={t15}>{t17}{t21}{t25}{t28}</form>;
    $[59] = t15;
    $[60] = t17;
    $[61] = t21;
    $[62] = t25;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== composerStatus || $[66] !== onRetry) {
    t30 = composerStatus && <div id="simulacao-status-do-envio" role={composerStatus.tone === "error" ? "alert" : "status"} className={`flex shrink-0 items-center justify-between gap-2 bg-neutral-100 px-3 pb-3 text-[10px] ${composerStatus.tone === "error" ? "text-error-600" : "text-neutral-600"}`}><span>{composerStatus.text}</span>{composerStatus.canRetry && <button type="button" onClick={onRetry} className="text-brand-700 shrink-0 font-semibold underline">Tentar novamente</button>}</div>;
    $[65] = composerStatus;
    $[66] = onRetry;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t11 || $[69] !== t14 || $[70] !== t29 || $[71] !== t30) {
    t31 = <aside className="flex w-full justify-center" aria-label="Conversa simulada com a Lexi"><div className="flex h-[700px] w-full max-w-[370px] flex-col overflow-hidden rounded-[28px] border-[5px] border-solid border-neutral-900 bg-[var(--bg-whatsapp-chat)]">{t4}{t11}{t14}{t29}{t30}</div></aside>;
    $[68] = t11;
    $[69] = t14;
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  return t31;
};
function _temp(index) {
  return <span key={index} aria-hidden="true" className="h-1.5 w-1.5 animate-bounce rounded-full bg-neutral-500" style={{
    animationDelay: `${index * 140}ms`
  }} />;
}